<template>
    <div @click="$emit('click')" class="hotelItem">
        <div :style="{ backgroundImage: `url('${$getImageUrl(cover)}')` }" class="bgi noImg leftImg"></div>
        <div class="rightInfo flex-1 flex-column jc-start ai-start shrink-0">
            <div>{{ title }}</div>
            <div v-if="type == 0">经济型</div>
            <div v-if="type == 1">舒适/三星</div>
            <div v-if="type == 2">高档/四星</div>
            <div v-if="type == 3">豪华/五星</div>
            <div style="max-width: 50vw;">
                {{ location }}
            </div>
            <div class="flex-1 jc-end ai-end width-100">
                <div>预定</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        cover: String,
        title: String,
        type: [String, Number],
        location: String,
    },
    data() {
        return {};
    },
};
</script>

<style lang="scss" scoped>
.hotelItem {
    background-color: #fff;
    padding: 2vw;
    box-sizing: border-box;
    $itemSize: 34vw;
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: $itemSize;
    border-radius: 2vw;
    overflow: hidden;
    margin-bottom: 2.5vw;
    .leftImg {
        border-radius: 2vw;
        width: $itemSize + 6vw;
        height: 100%;
        flex-shrink: 0;
        margin-right: 2vw;
    }
    .rightInfo {
        > div:first-child {
            font-size: 4vw;
            font-weight: bold;
            @extend .text-two;
        }
        > div:nth-child(2) {
            margin-top: 1.5vw;
            color: #5a5a5a;
            font-size: 3.5vw;
        }
        > div:nth-child(3) {
            margin-top: 1vw;
            color: #5a5a5a;
            width: 100%;
            font-size: 3.5vw;
            @extend .text-one;
        }
        > div:nth-child(4) > div {
            padding: 1.3vw 4vw;
            border-radius: 4vw;
            /* background-color: #fbe3b3; */
            background: linear-gradient(90deg,#fde59f,#ebb06c);
            margin-right: 2vw;
            font-size: 3.5vw;
            box-shadow: 0 0 3px rgba($color: #000000, $alpha: 0.1);
            // align-self: flex-end;
            // justify-self: flex-end;
            // place-self: flex-end;
        }
    }
}
</style>
